import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Customers, CustomersResults } from '../../models/customers.model';

import { environment } from 'src/environments/environment';

const baseUrl = environment.baseUrl

@Injectable({
    providedIn: 'root'
})
export class SharedCustomersService {

    constructor(
        private http: HttpClient
    ) { }

    getCustomers(limit: number, offset: number, search?: string, active?: boolean, filters?: any): Observable<Customers> {
        let params = new HttpParams();

        if (limit) params = params.append('limit', limit.toString());
        if (offset) params = params.append('offset', offset.toString());
        if (search) params = params.append('search', search);
        if (active) params = params.append('active', 'true');
        if (filters) {
            if (filters['has_no_product_list']) params = params.append('has_product_list', 'false')
            if (filters['has_no_price_list']) params = params.append('has_percent_list', 'false')
            if (filters['has_no_gateway_list']) params = params.append('has_payment_list', 'false')
            if (filters['city__state__country']) params=params.append('city__state__country',filters['city__state__country'])
            if (filters['office']) params=params.append('office',filters['office'])
        }

        return this.http.get<Customers>(`${baseUrl}/customers/my_customers/`, { params })
    }

    getAllCustomers(filters?: any): Observable<any> {
         let params = new HttpParams();
        for (const filter in filters) {
            if (filters[filter]) {
                params = params.append(filter, filters[filter]);
            }
        }
        return this.http.get<Customers>(`${baseUrl}/customers/my-customers-all/`, {params})
    }

    getUserDetail(id: number): Observable<CustomersResults> {
        const userId = id ? id : '';
        return this.http.get<CustomersResults>(`${baseUrl}/customers/my_customers/${userId}/`)
    }

    getCustomerProductList(filters): Observable<any> {
        let params = new HttpParams();
        for (let filter in filters) {
            if (filters[filter]) {
                params = params.append(filter, filters[filter]);
            }
        }

        return this.http.get(`${baseUrl}/cards/product_lists/`, { params });
    }

    assignUserCustomerList(id, userID) {
        return this.http.post(`${baseUrl}/cards/product_lists/${id}/assign_to_user/`, {
            user_id: userID
        })
    }

    getSellerPins(filters): Observable<any> {
        let params = new HttpParams();
        for (const filter in filters) {
            if (filters[filter]) {
                params = params.append(filter, filters[filter]);
            }
        }

        return this.http.get(`${baseUrl}/customers/customer_pins/`, { params });
    }

    getAdminCountrySummary(): Observable<any> {
        return this.http.get(`${baseUrl}/customers/user-per-country/`)
    }

    getActiveSessionList(filters): Observable<any> {
        let params = new HttpParams();
        for (const filter in filters) {
            if (filters[filter]) {
                params = params.append(filter, filters[filter]);
            }
        }

        return this.http.get(`${baseUrl}/customers/active-session/`, { params }); 
    }

    revokeSession(data): Observable<any> {
        return this.http.post(`${baseUrl}/customers/active-session/`, data); 
    }
}
